import React from "react";

import { componentNanoid } from "../../utils/componentNanoid";

import BodyCell, { BodyCellProps } from "./BodyCell";

export type RowData = BodyCellProps[];

export type BodyRowProps = {
    cells: RowData;
};

const BodyRow = ({ cells }: BodyRowProps) => {
    return (
        <tr>
            {cells.map((cell) => (
                <BodyCell key={`cell-${componentNanoid()}`} {...cell} />
            ))}
        </tr>
    );
};

export default BodyRow;
